import { useState, useMemo } from "react";

const useGrazeBoxSelections = (product) => {
  const [selectedSize, setSelectedSize] = useState(product.sizes[0] || null);
  const [selectedDiet, setSelectedDiet] = useState(
    product.dietaryOptions[0] || null
  );
  const [giftPackaging, setGiftPackaging] = useState(false);

  const totalPrice = useMemo(() => {
    const sizePrice = selectedSize?.price || 0;
    const dietAdjustment =
      selectedDiet?.priceAdjustments?.find(
        (adj) => adj.sizeId === selectedSize?.sizeId
      )?.amount || 0;
    const giftPackagingPrice = giftPackaging ? 3 : 0;

    return sizePrice + dietAdjustment + giftPackagingPrice;
  }, [selectedSize, selectedDiet, giftPackaging]);

  return {
    selectedSize,
    setSelectedSize,
    selectedDiet,
    setSelectedDiet,
    giftPackaging,
    setGiftPackaging,
    totalPrice,
  };
};

export default useGrazeBoxSelections;
